module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3bf6b664e3628a62c4bc3f6a67b5c2b6.png";